import Enum from "../Enum";

export default Enum.create( {
	DIAGNOSTIC: "DIAGNOSTIC",
	GOAL_COMMENT: "GOAL_COMMENT",
	GOAL_CREATED: "GOAL_CREATED",
	GOAL_DELETED: "GOAL_DELETED",
	GOAL_UPDATED: "GOAL_UPDATED",
	HEALTH_SURVEY_CREATED: "HEALTH_SURVEY_CREATED",
	HEALTH_SURVEY_RESPONSE_COMPLETED: "HEALTH_SURVEY_RESPONSE_COMPLETED",
	HEALTH_SURVEY_UPDATED: "HEALTH_SURVEY_UPDATED",
	KEYRESULT_COMMENT: "KEYRESULT_COMMENT",
	KEYRESULT_CREATED: "KEYRESULT_CREATED",
	KEYRESULT_DELETED: "KEYRESULT_DELETED",
	KEYRESULT_UPDATED: "KEYRESULT_UPDATED",
	OUTCOME_CREATED: "OUTCOME_CREATED",
	OUTCOME_DELETED: "OUTCOME_DELETED",
	OUTCOME_UPDATED: "OUTCOME_UPDATED",
	STREAM_RECURRENCE_UPDATED: "STREAM_RECURRENCE_UPDATED",
	STREAM_SUBDOC_UPDATED: "STREAM_SUBDOC_UPDATED",
	TEAM_CREATED: "TEAM_CREATED",
	TEAM_DELETED: "TEAM_DELETED",
	TEAM_UPDATED: "TEAM_UPDATED",
	USER_UPDATED: "USER_UPDATED",
} );
